type PrefixerFn<RP extends string, M extends string> = <T extends string>(permission: T) => `${RP}-${M}-${T}`

type PermissionSubtree = {
    _perm: string
    [k: string]: string | PermissionSubtree
}
type PermissionTree = {
    _root: string
    _resource: string
    mantenimiento?: PermissionSubtree
    transacciones?: PermissionSubtree
    configuracion?: PermissionSubtree
    informes?: PermissionSubtree
}

const createPrefixer =
    <RP extends string, Module extends string>(rootPermission: RP, mod: Module): PrefixerFn<RP, Module> =>
    <T extends string>(value: T) => `${rootPermission}-${mod}-${value}`

let printPermissionTree: undefined | ((v: PermissionTree, conResource?: boolean) => void) = undefined

if (import.meta.env.DEV) {
    /**
     * Esto es solo de ayuda en caso de necesitar el arbol de permisos
     */
    printPermissionTree = permission => {
        const output: string[] = [permission._root]
        const unrollSubtree  = (subtree: PermissionSubtree) => {
            Object.entries(subtree)
                .forEach(([k, permission]) => {
                    if (typeof permission !== 'string') {
                        unrollSubtree(permission)
                        return
                    }
                    if (output.includes(permission)) return
                    output.push(permission)
                })
        }
        Object.entries(permission)
            .filter(([key]) => ['mantenimiento', 'transacciones', 'informes', 'configuracion'].includes(key))
            .forEach(([_, tree]) => {
                output.push((tree as PermissionSubtree)._perm)
                unrollSubtree(tree as PermissionSubtree)
            })
        console.log(output)
    }
}

export { printPermissionTree, createPrefixer }
